import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { z } from 'zod';

const phoneSchema = z.string().superRefine((value, ctx) => {
    const raw = value.trim();
    // Extract digits only for analysis
    const digitsOnly = raw.replaceAll(/[^\d]/g, '');
    // Handle different US phone number formats:
    // - 10 digits: US national format (e.g., "7045761096")
    // - 11 digits starting with 1: US with country code (e.g., "17045761096")
    // - Starts with +: International format (e.g., "+1 (704) 576-1096")
    const is10DigitUS = /^\d{10}$/.test(digitsOnly) && !raw.startsWith('+');
    const is11DigitUS = /^1\d{10}$/.test(digitsOnly) && !raw.startsWith('+');
    let phone;
    if (is10DigitUS) {
        // 10-digit US number
        phone = parsePhoneNumberFromString(digitsOnly, 'US');
    }
    else if (is11DigitUS) {
        // 11-digit US number (with country code 1)
        phone = parsePhoneNumberFromString(digitsOnly, 'US');
    }
    else if (raw.startsWith('+')) {
        // International format with + prefix
        phone = parsePhoneNumberFromString(raw);
    }
    else {
        // Try parsing as-is (might be formatted international without +)
        phone = parsePhoneNumberFromString(raw);
    }
    if (!phone?.isValid()) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Enter a valid phone number',
        });
        return;
    }
    // Enforce "US must be valid US" (already true if isValid, but this ensures region expectation)
    if ((is10DigitUS || is11DigitUS) && phone.country !== 'US') {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Enter a valid US phone number',
        });
    }
});
// Optional: normalize to E.164 after parse succeeds
const phoneSchemaE164 = phoneSchema.transform((raw) => {
    const digitsOnly = raw.trim().replaceAll(/[^\d]/g, '');
    const is10DigitUS = /^\d{10}$/.test(digitsOnly) && !raw.trim().startsWith('+');
    const is11DigitUS = /^1\d{10}$/.test(digitsOnly) && !raw.trim().startsWith('+');
    let phone;
    if (is10DigitUS || is11DigitUS) {
        phone = parsePhoneNumberFromString(digitsOnly, 'US');
    }
    else {
        phone = parsePhoneNumberFromString(raw.trim());
    }
    return phone.number; // E.164 like +14155552671
});

export { phoneSchema, phoneSchemaE164 };
//# sourceMappingURL=phone.js.map
